import { LOGOUT_RTK } from "@/components/access/ducks/Actions"
import {
  UPDATE_ASSIGN_BY,
  UPDATE_ASSIGNED,
  UPDATE_TASK_DESCRIPTION,
  UPDATE_TASK_DUE_DATE,
  UPDATE_TASK_ID,
  UPDATE_TASK_STATUS,
  UPDATE_TASK_TITLE,
} from "@/components/tasks/admin/ducks/Actions"
import { UNMOUNT_TASK, UPDATE_USER_TASK } from "@/components/tasks/ducks/Actions"
import moment from "moment"

const defaultState = {
  taskTitle: "",
  assignBy: "constituent",
  assigned: "",
  taskDueDate: "",
  taskDescription: "",
  taskId: "",
  taskStatus: "",
}

const userTasksReducer = (oldState = defaultState, action) => {
  Object.freeze(oldState)
  switch (action.type) {
    case LOGOUT_RTK.type:
      return defaultState

    case UPDATE_USER_TASK:
      return {
        ...oldState,
        taskTitle: action.task.name,
        taskDescription: action.task.description,
        taskDueDate: moment.utc(action.task.dueDate * 1000).format("YYYY-MM-DD"),
        assigned: {
          constituentId: action.task.assignedConstituentId,
          name: action.task.assignedConstituentName,
        },
        assignBy: "constituent",
        taskId: action.task.id,
        taskStatus: action.task.status,
      }

    case UPDATE_TASK_TITLE:
      return {
        ...oldState,
        taskTitle: action.taskTitle,
      }

    case UPDATE_ASSIGN_BY:
      return {
        ...oldState,
        assignBy: action.assignBy,
      }

    case UPDATE_ASSIGNED:
      return {
        ...oldState,
        assigned: action.assigned,
      }

    case UPDATE_TASK_DUE_DATE:
      return {
        ...oldState,
        taskDueDate: action.taskDueDate,
      }

    case UPDATE_TASK_ID:
      return {
        ...oldState,
        taskId: action.taskId,
      }

    case UPDATE_TASK_STATUS:
      return {
        ...oldState,
        taskStatus: action.taskStatus,
      }

    case UPDATE_TASK_DESCRIPTION:
      return {
        ...oldState,
        taskDescription: action.taskDescription,
      }

    case UNMOUNT_TASK:
      return defaultState

    default:
      return oldState
  }
}

export default userTasksReducer
